import { useContext, useEffect, useMemo } from "react";
import { DashboardContext } from "../context/DashboardContexProvider";
import { Responsive, WidthProvider } from "react-grid-layout";
import {
  parseLayoutConfigToLayouyts,
  parseLayoutsToLayoutConfig,
} from "../layoutsMapper";
import { getCardChildrenByTypeAndProps } from "../CardChildrenSelector";
import Loading from "../../../main/components/Loading";
import CardBox from "../../../main/components/CardBox";
import { breakpoints } from "../../../main/themes/defaultLayoutData";
import { MainContext } from "../../../main/context/MainContextProvider";
import {
  filterTrackerFromCardsConfig,
  filterTrackerFromLayouts,
} from "../helpers/trackerCardVisibility";

export const ResponsiveGridLayout = WidthProvider(Responsive);

export function DashboardBody(props: { bodyWidth: number }) {
  const { bodyWidth } = props;
  const {
    layoutsConfig,
    setLayoutsConfig,
    cardsConfig,
    canEditLayout,
    cardsDisplayableColorProps,
    selectedUsinaHasTrackers,
  } = useContext(DashboardContext);

  const visibleCardsConfig = useMemo(
    () =>
      selectedUsinaHasTrackers === true
        ? cardsConfig
        : filterTrackerFromCardsConfig(cardsConfig),
    [cardsConfig, selectedUsinaHasTrackers],
  );

  const visibleLayoutsConfig = useMemo(
    () =>
      selectedUsinaHasTrackers === true
        ? layoutsConfig
        : filterTrackerFromLayouts(layoutsConfig),
    [layoutsConfig, selectedUsinaHasTrackers],
  );

  const { isLoadingDashboard, setIsLoadingDashboard, theme } = useContext(MainContext);

  useForceResponsiveGridLayoutRender(450, setIsLoadingDashboard, bodyWidth);

  useEffect(() => {
    setIsLoadingDashboard(true);
    setTimeout(() => {
      setIsLoadingDashboard(false);
    }, 200);
    //TODO: Aplicar o filtro de usina na consulta dos dados em tempo real, e remover o código acima
  }, [cardsDisplayableColorProps]);

  return (
    <>
      {!isLoadingDashboard ? (
        <ResponsiveGridLayout
          compactType={null}
          rowHeight={150}
          margin={[10, 10]}
          className="layout"
          layouts={parseLayoutConfigToLayouyts(visibleLayoutsConfig, canEditLayout)}
          breakpoints={{
            lg: breakpoints.lg,
            md: breakpoints.md,
            sm: breakpoints.sm,
            xs: breakpoints.xs,
            xxs: breakpoints.xxs,
          }}
          cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 1 }}
          onLayoutChange={(_, layouts) => {
            // esse console traz o estado atual do layout
            // console.log("layouts atuais", layouts)
            setLayoutsConfig(
              parseLayoutsToLayoutConfig(layouts, layoutsConfig.id)
            );
          }}
          width={bodyWidth}
        >
          {/* backgroundColor: 'rgba(209,204,218, 0.05)' */}
          {visibleCardsConfig.map((cardConfig) => (
            <div key={cardConfig.id}>
              <CardBox removeShadow sx={{ width: "100%", height: "100%", backgroundColor: theme.cardBoxBackgroudColor }}>
                {getCardChildrenByTypeAndProps(
                  cardConfig.childrenType,
                  cardConfig.childrenProps,
                  cardConfig.id
                )}
              </CardBox>
            </div >
          ))
          }
        </ResponsiveGridLayout >
      ) : (
        <Loading />
      )}
    </>
  );
}

/**
 * Adaptação utilizada para resize do componente de responsive grid layout a partir do tempo de animação do recolhimento/expansão da barra lateral.
 *
 * @param time Parâmetro opcional que define o tempo de animação do recolhimento/expansão da barra lateral.
 * @param setIsChangingSize Função que define se o componente está em processo de resize.
 * @param bodyWidth Largura do componente.
 *
 */
function useForceResponsiveGridLayoutRender(
  time: number = 300,
  setIsChangingSize: React.Dispatch<React.SetStateAction<boolean>>,
  bodyWidth: number
) {
  useEffect(() => {
    setIsChangingSize(true);
    setTimeout(() => {
      setIsChangingSize(false);
    }, time);
  }, [bodyWidth]);
}
